"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _floorToDecimal = _interopRequireDefault(require("./floorToDecimal"));

var floorForPrecision = function floorForPrecision(n) {
  var decimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
  return (0, _floorToDecimal["default"])(n, decimal);
};

var _default = floorForPrecision;
exports["default"] = _default;